export default `
   query GetProductsList($FeaturedProductsFilterId: String, $newProductsFilterId: String) {
  FeaturedProducts: products(
    filter: { category_id: { eq: $FeaturedProductsFilterId } }
    pageSize: 10
    currentPage: 1
  ) {
    items {
      uid
      sku
      name
      thumbnail {
        url
      }
      url_key
      price_range {
        maximum_price {
          final_price {
            currency
            value
          }
          regular_price {
            currency
            value
          }
        }
        minimum_price {
          final_price {
            currency
            value
          }
          regular_price {
            currency
            value
          }
        }
      }
    }
  }
  NewProducts: products(
    filter: { category_id: { eq: $newProductsFilterId } }
    pageSize: 10
    currentPage: 1
  ) {
    items {
      uid
      sku
      name
      thumbnail {
        url
      }
      url_key
      price_range {
        maximum_price {
          final_price {
            currency
            value
          }
          regular_price {
            currency
            value
          }
        }
        minimum_price {
          final_price {
            currency
            value
          }
          regular_price {
            currency
            value
          }
        }
      }
    }
  }
}

`;
